@if (isRouterTab()) {
  <a class="tab-label" [routerLink]="routerLink()" routerLinkActive="active">
    {{ label() }}
  </a>
} @else {
  <span class="tab-label" [class.active]="isActive()" (click)="tabClick.emit()">{{ label() }}</span>
}
